var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 89 66.53 H 1 c -0.552 0 -1 -0.447 -1 -1 V 24.469 c 0 -0.552 0.448 -1 1 -1 h 88 c 0.553 0 1 0.448 1 1 V 65.53 C 90 66.083 89.553 66.53 89 66.53 z M 2 64.53 h 86 V 25.469 H 2 V 64.53 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 60.592 c -8.597 0 -15.591 -6.994 -15.591 -15.592 c 0 -8.597 6.994 -15.591 15.591 -15.591 c 8.598 0 15.592 6.994 15.592 15.591 C 60.592 53.598 53.598 60.592 45 60.592 z M 45 31.409 c -7.494 0 -13.591 6.097 -13.591 13.591 S 37.506 58.592 45 58.592 S 58.592 52.494 58.592 45 S 52.494 31.409 45 31.409 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.861 53.306 c -2.312 0 -4.344 -1.203 -5.178 -3.065 c -0.226 -0.505 0 -1.096 0.504 -1.322 c 0.503 -0.223 1.095 0 1.321 0.504 c 0.504 1.127 1.852 1.884 3.353 1.884 c 1.501 0 2.849 -0.757 3.353 -1.883 c 0.229 -0.56 0.254 -1.038 0.064 -1.435 c -0.363 -0.759 -1.529 -1.423 -3.564 -2.03 c -1.804 -0.538 -3.979 -1.375 -4.797 -3.084 c -0.44 -0.921 -0.43 -1.959 0.031 -3.084 c 0.847 -1.893 2.88 -3.096 5.191 -3.096 c 2.312 0 4.344 1.204 5.178 3.066 c 0.226 0.504 0 1.096 -0.505 1.321 c -0.508 0.226 -1.096 -0.001 -1.321 -0.504 c -0.504 -1.127 -1.852 -1.884 -3.352 -1.884 c -1.501 0 -2.849 0.757 -3.354 1.884 c -0.229 0.559 -0.253 1.038 -0.064 1.434 c 0.363 0.759 1.529 1.423 3.564 2.03 c 1.804 0.538 3.979 1.375 4.796 3.083 c 0.441 0.922 0.431 1.96 -0.029 3.085 C 49.206 52.103 47.173 53.306 44.861 53.306 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.861 55.386 c -0.552 0 -1 -0.447 -1 -1 v -2.08 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 2.08 C 45.861 54.938 45.413 55.386 44.861 55.386 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.861 38.694 c -0.552 0 -1 -0.448 -1 -1 v -2.08 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 2.08 C 45.861 38.247 45.413 38.694 44.861 38.694 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.042 60.592 H 6.939 c -0.552 0 -1 -0.447 -1 -1 V 30.409 c 0 -0.552 0.448 -1 1 -1 h 18.445 c 0.552 0 1 0.448 1 1 s -0.448 1 -1 1 H 7.939 v 27.183 h 24.103 c 0.552 0 1 0.447 1 1 S 32.594 60.592 32.042 60.592 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.042 31.409 H 29.62 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 2.422 c 0.552 0 1 0.448 1 1 S 32.594 31.409 32.042 31.409 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83.061 60.592 H 64.616 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 h 17.444 V 31.409 H 57.958 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 25.103 c 0.553 0 1 0.448 1 1 v 29.183 C 84.061 60.145 83.613 60.592 83.061 60.592 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 60.381 60.592 h -2.423 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 h 2.423 c 0.553 0 1 0.447 1 1 S 60.934 60.592 60.381 60.592 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 78.172 46 h -3.914 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 3.914 c 0.553 0 1 0.448 1 1 S 78.725 46 78.172 46 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.742 46 h -3.914 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 3.914 c 0.552 0 1 0.448 1 1 S 16.294 46 15.742 46 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.185 48.444 c -1.899 0 -3.444 -1.545 -3.444 -3.444 s 1.545 -3.444 3.444 -3.444 s 3.444 1.545 3.444 3.444 S 24.084 48.444 22.185 48.444 z M 22.185 43.556 c -0.796 0 -1.444 0.648 -1.444 1.444 s 0.648 1.444 1.444 1.444 s 1.444 -0.648 1.444 -1.444 S 22.981 43.556 22.185 43.556 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 67 48.444 c -1.899 0 -3.444 -1.545 -3.444 -3.444 s 1.545 -3.444 3.444 -3.444 s 3.444 1.545 3.444 3.444 S 68.899 48.444 67 48.444 z M 67 43.556 c -0.797 0 -1.444 0.648 -1.444 1.444 s 0.647 1.444 1.444 1.444 s 1.444 -0.648 1.444 -1.444 S 67.797 43.556 67 43.556 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(40,147,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar1);
export default __webpack_public_path__ + "static/media/dollar1.3b57858988d5028d0213dea56e971f14.svg";
export { ForwardRef as ReactComponent };